import styled from 'styled-components';

const Image = styled.img`
  display: block;
`;

export default Image;
